import { useEffect, useRef, type ReactNode } from "react";

/**
 * Shared by live creator headers and template previews. With `menu="button"` the links stay
 * behind the menu button at every width, from the first paint.
 */
export function HeaderLayout({ children, menu }: { children: ReactNode; menu?: "button" }) {
  const root = useRef<HTMLDivElement>(null);
  useEffect(() => {
    let cancelled = false;
    let dispose: (() => void) | undefined;
    void import("../../src/ui/header-layout").then(({ mountHeaderLayout }) => {
      if (!cancelled && root.current) dispose = mountHeaderLayout(root.current);
    });
    return () => {
      cancelled = true;
      dispose?.();
    };
  }, []);
  return (
    <div
      ref={root}
      className="container header-inner"
      data-menu={menu}
      data-header-navigation={menu === "button" ? "menu" : undefined}
    >
      {children}
    </div>
  );
}
